import type { IconSvgObject } from './types';

const TradeMarkIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.99414 9.47593H8.5095M8.5095 9.47593H10.9932M8.5095 9.47593V15.4958M12.9904 15.4863V9.47598C13.3259 9.36901 15.5002 11.4773 15.5002 11.4773C15.5002 11.4773 17.6725 9.36901 18.0081 9.47599V15.4863", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TradeMarkIcon;
